import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import moment from 'moment';

const state = {
    resultadosProveedoresCompras: [],
    // cantidadProveedoresResultadoProveedoresCompras: 10,
    cantidadProveedoresResultadoProveedoresCompras: 21,
    resultadosProveedoresComprasLabels: [],
    resultadosProveedoresComprasColors: [],
    resultadosProveedoresComprasData: [],

    resultadosProveedoresGastos: [],

    resultadosOrdenesProveedores: [],
    resultadosOrdenesProveedoresLabels: [],
    resultadosOrdenesProveedoresColors: [],
    resultadosOrdenesProveedoresData: [],

    resultadosRankingPresupuestos: [],
    resultadosRankingPresupuestosLabels: [],
    resultadosRankingPresupuestosColors: [],
    resultadosRankingPresupuestosData: [],

    indicadorRentabilidadOrdenes: {},

    resultados: []
};

const mutations = {
    updateField,

    'INICIALIZAR_INDICADORES' (state) {
        state.resultadosProveedoresCompras = [];
        state.resultadosProveedoresComprasLabels = [];
        state.resultadosProveedoresComprasColors = [ 
            '#E46651', 
            '#41B883', 
            '#FAFA05', 
            '#0000FF', 
            '#FFA500',
            '#17A204',
            '#04A29D',
            '#08CADD',
            '#DD08C6',
            '#AA1FC8',
            '#9B9B9B'
        ];
        state.resultadosProveedoresComprasData = [];

        state.resultadosProveedoresGastos = [];

        state.resultadosOrdenesProveedores = [];
        state.resultadosOrdenesProveedoresLabels = [];
        state.resultadosOrdenesProveedoresColors = [ 
            '#E46651', 
            '#41B883', 
            '#FAFA05', 
            '#0000FF', 
            '#FFA500',
            '#17A204',
            '#04A29D',
            '#08CADD',
            '#DD08C6',
            '#AA1FC8',
            '#9B9B9B'
        ];
        state.resultadosOrdenesProveedoresData = [];

        state.resultadosRankingPresupuestos = [];
        state.resultadosRankingPresupuestosLabels = [];
        state.resultadosRankingPresupuestosColors = [ 
            '#E46651', 
            '#41B883', 
            '#FAFA05', 
            '#0000FF', 
            '#FFA500',
            '#17A204',
            '#04A29D',
            '#08CADD',
            '#DD08C6',
            '#AA1FC8',
            '#8398CA',
            '#F19D6E',
            '#D2DE36',
            '#2DA1D9',
            '#E62371',
            '#F06F72',
            '#97D5D7',
            '#F0CF71',
            '#F5CEB5',
            '#4061AC',
            '#9B9B9B'
        ];
        state.resultadosRankingPresupuestosData = [];
    
        state.indicadorRentabilidadOrdenes = {};
    },
    'SET_RESULTADOS_PROVEEDORES_COMPRAS'(state, resultadosProveedoresCompras) {
        /* Grafico de Torta */
        if (resultadosProveedoresCompras) {
            state.resultadosProveedoresCompras = resultadosProveedoresCompras.map(resultadoProveedor => ({
                ...resultadoProveedor,
                porcentaje: roundNumber(parseFloat(resultadoProveedor.pjeParticipacion) * parseFloat(100), 2)
            }))
        }

        state.resultadosProveedoresCompras.sort(function(a, b){
            let x = a.montoNeto;
            let y = b.montoNeto;
            if (x < y) { 
                return 1; 
            }
            if (x > y) {
                return -1;
            }
            return 0;
        });

        for (let index = 0; index < state.resultadosProveedoresCompras.length; index++) {
            if (index < state.resultadosProveedoresComprasColors.length) {
                state.resultadosProveedoresCompras[index].color = state.resultadosProveedoresComprasColors[index];
            }
        }

        state.resultadosProveedoresComprasLabels = state.resultadosProveedoresCompras
            .map(resultadoProveedor => resultadoProveedor.proveedor.trim());
        
        state.resultadosProveedoresComprasData = state.resultadosProveedoresCompras
            .map(resultadoProveedor => parseFloat(resultadoProveedor.porcentaje));
    },

    'INICIALIZAR_RESULTADOS'(state) {
        state.resultados = [];
    },
    'SET_RESULTADOS'(state, resultados) {
        state.resultados = resultados;
    },

    'SET_RESULTADOS_PROVEEDORES_GASTOS'(state, resultadosProveedoresGastos) {
        if (resultadosProveedoresGastos) {
            state.resultadosProveedoresGastos = resultadosProveedoresGastos.map(resultadoProveedor => ({
                ...resultadoProveedor,
                porcentaje: roundNumber(parseFloat(resultadoProveedor.pjeParticipacion) * parseFloat(100), 2)
            }))

            state.resultadosProveedoresGastos.sort(function(a, b){
                let x = a.montoNeto;
                let y = b.montoNeto;
                if (x < y) { 
                    return 1; 
                }
                if (x > y) {
                    return -1;
                }
                return 0;
            });
    
        }
    },

    /* Ranking de Ordenes (por cantidad) */
    'SET_RESULTADOS_ORDENES_PROVEEDORES'(state, resultados) {
        if (resultados) {
            state.resultadosOrdenesProveedores = resultados.map(proveedor => ({
                ...proveedor,
                pjeParticipacion: parseFloat(proveedor.pjeParticipacion) * parseFloat(100)
            }));
        }

        for (let index = 0; index < state.resultadosOrdenesProveedores.length; index++) {
            if (index < state.resultadosOrdenesProveedoresColors.length) {
                state.resultadosOrdenesProveedores[index].color = state.resultadosOrdenesProveedoresColors[index];
            }
        }

        state.resultadosOrdenesProveedoresLabels = state.resultadosOrdenesProveedores
            .map(resultadoProveedor => resultadoProveedor.proveedor.trim());
        
        state.resultadosOrdenesProveedoresData = state.resultadosOrdenesProveedores
            .map(resultadoProveedor => roundToTwo(parseFloat(resultadoProveedor.pjeParticipacion)));
    },
    /* Ranking de Presupuestos (por cantidad) */
    'SET_RESULTADOS_RANKING_PRESUPUESTOS'(state, resultados) {
        state.resultadosRankingPresupuestos = resultados;

        for (let index = 0; index < state.resultadosRankingPresupuestos.length; index++) {
            if (index < state.resultadosRankingPresupuestosColors.length) {
                state.resultadosRankingPresupuestos[index].color = state.resultadosRankingPresupuestosColors[index];
            }
        }

        state.resultadosRankingPresupuestosLabels = state.resultadosRankingPresupuestos
            .map(resultadoProveedor => resultadoProveedor.proveedor.trim());
        
        state.resultadosRankingPresupuestosData = state.resultadosRankingPresupuestos
            .map(resultadoProveedor => roundToTwo(parseFloat(resultadoProveedor.pjeParticipacion)));
    },

    'INICIALIZAR_INDICADOR_RENTABILIDAD_ORDENES' (state) {
        state.indicadorRentabilidadOrdenes = {};
    },
    'SET_INDICADOR_RENTABILIDAD_ORDENES'(state, indicador) {
        state.indicadorRentabilidadOrdenes = indicador;

        state.indicadorRentabilidadOrdenes.pjeActual = roundToTwo(parseFloat(indicador.ordenesRentabilidadNegativa) / parseFloat(indicador.ordenesTotal) * 100.0);
    },
    
    'SET_RESULTADOS_INDICADOR_RENTABILIDAD_ORDENES'(state, resultados) {
        state.resultados = resultados;
    },
    'SET_RESULTADOS_INDICADOR_RENTABILIDAD_ORDENES_NEGATIVAS'(state, resultados) {
        state.resultados = resultados;
    },

};

function roundToTwo(num) {    
    return +(Math.round(num + 'e+2')  + 'e-2');
}

function roundNumber(num, scale) {
    if(!("" + num).includes("e")) {
        return +(Math.round(num + "e+" + scale)  + "e-" + scale);
    } else {
        var arr = ("" + num).split("e");
        var sig = ""
        if(+arr[1] + scale > 0) {
        sig = "+";
        }
        return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
    }
} 

const getters = {
    getField,

    resultadosProveedoresCompras(state) {
        return state.resultadosProveedoresCompras;
    },
    resultadosProveedoresComprasLabels(state) {
        return state.resultadosProveedoresComprasLabels;
    },
    resultadosProveedoresComprasColors(state) {
        return state.resultadosProveedoresComprasColors;
    },
    resultadosProveedoresComprasData(state) {
        return state.resultadosProveedoresComprasData;
    },
    resultadosProveedoresGastos(state) {
        return state.resultadosProveedoresGastos;
    },

    resultadosOrdenesProveedores(state) {
        return state.resultadosOrdenesProveedores;
    },
    resultadosOrdenesProveedoresLabels(state) {
        return state.resultadosOrdenesProveedoresLabels;
    },
    resultadosOrdenesProveedoresColors(state) {
        return state.resultadosOrdenesProveedoresColors;
    },
    resultadosOrdenesProveedoresData(state) {
        return state.resultadosOrdenesProveedoresData;
    },

    resultadosRankingPresupuestos(state) {
        return state.resultadosRankingPresupuestos;
    },
    resultadosRankingPresupuestosLabels(state) {
        return state.resultadosRankingPresupuestosLabels;
    },
    resultadosRankingPresupuestosColors(state) {
        return state.resultadosRankingPresupuestosColors;
    },
    resultadosRankingPresupuestosData(state) {
        return state.resultadosRankingPresupuestosData;
    },

    indicadorRentabilidadOrdenes(state) {
        return state.indicadorRentabilidadOrdenes;
    },

    resultados(state) {
        return state.resultados;
    },
};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES');
            resolve();
        })
    },
    getResultadosProveedoresCompras ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/produccion/proveedores')
                .then(res => {
                    commit('SET_RESULTADOS_PROVEEDORES_COMPRAS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getResultadosProveedoresComprasDetalle ( { commit }, proveedorId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS');

            apiAxios.get(`indicadores/produccion/proveedores/${proveedorId}`)
                .then(res => {
                    commit('SET_RESULTADOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getResultadosProveedoresGastos ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/produccion/proveedores/gastos')
                .then(res => {
                    commit('SET_RESULTADOS_PROVEEDORES_GASTOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getResultadosProveedoresGastosDetalle ( { commit }, proveedorId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS');

            apiAxios.get(`indicadores/produccion/proveedores/gastos/${proveedorId}`)
                .then(res => {
                    commit('SET_RESULTADOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getResultadosOrdenesProveedores ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/produccion/ordenes')
                .then(res => {
                    commit('SET_RESULTADOS_ORDENES_PROVEEDORES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getResultadosRankingPresupuestos ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/produccion/presupuestos')
                .then(res => {
                    commit('SET_RESULTADOS_RANKING_PRESUPUESTOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadorRentabilidadOrdenes ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADOR_RENTABILIDAD_ORDENES');
            
            apiAxios.get('indicadores/ordenes-trabajo/rentabilidad')
                .then(res => {
                    commit('SET_INDICADOR_RENTABILIDAD_ORDENES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getResultadosIndicadorRentabilidadOrdenes ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/ordenes-trabajo/rentabilidad/ordenes')
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_ORDENES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getResultadosIndicadorRentabilidadOrdenesNegativas ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/ordenes-trabajo/rentabilidad/ordenes-negativas')
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_ORDENES_NEGATIVAS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}